module.exports = __webpack_public_path__ + "img/Pro-money truck-mobile.bb5bb356.jpg";